var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLabel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_56_1417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5333 3.2998L27.732 5.18647L29.6173 18.3865L17.3613 30.6425C17.1113 30.8924 16.7722 31.0329 16.4187 31.0329C16.0651 31.0329 15.726 30.8924 15.476 30.6425L2.276 17.4425C2.02604 17.1924 1.88562 16.8534 1.88562 16.4998C1.88562 16.1463 2.02604 15.8072 2.276 15.5571L14.5333 3.2998ZM15.476 6.12914L5.104 16.4998L16.4187 27.8131L26.7893 17.4425L25.376 7.54247L15.476 6.12914ZM18.3027 14.6145C17.8025 14.1141 17.5215 13.4355 17.5217 12.728C17.5217 12.3777 17.5908 12.0308 17.7249 11.7072C17.859 11.3835 18.0556 11.0895 18.3033 10.8418C18.5511 10.5941 18.8452 10.3977 19.1689 10.2637C19.4926 10.1297 19.8395 10.0607 20.1898 10.0608C20.8973 10.0609 21.5758 10.3421 22.076 10.8425C22.5762 11.3428 22.8571 12.0214 22.857 12.7289C22.8569 13.4365 22.5757 14.1149 22.0753 14.6151C21.575 15.1153 20.8964 15.3963 20.1889 15.3961C19.4814 15.396 18.8029 15.1148 18.3027 14.6145Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_1417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabel);
export default __webpack_public_path__ + "static/media/Label.f2c021af58cdec26ad936d0c627aa202.svg";
export { ForwardRef as ReactComponent };